// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Supplier } from './supplier';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class SupplierImage extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** String(200) */
  apiLink?: string;
  /** Binary */
  data!: any;
  /** String(250) */
  description?: string;
  /** String(512) */
  fileName!: string;
  /** Int16 */
  height?: number;
  /** Boolean */
  isThumbnail!: boolean;
  /** String(255) */
  mimeType!: string;
  /** String(512) */
  name!: string;
  /** Binary */
  rowVersion!: any;
  /** Guid FK supplier */
  supplierId!: string;
  /** Int16 */
  width?: number;
  /** FK supplierId */
  supplier!: Supplier;
}

